'use client';

import { Fragment } from 'react';
import Image from 'next/image';
import styles from './ExpertTeam.module.scss';
import { useAOS } from '@/src/lib/hooks/useAOS';

interface ExpertTeamProps {
  eyebrow?: string;
  title?: string;
  highlightedTitle?: string;
  description?: string;
  appImage?: string;
  appAlt?: string;
  tilt?: 'left' | 'right';
  id?: string;
}

const renderTitle = (text: string) => {
  const parts = text.split('*');
  return parts.map((part, i) =>
    i % 2 === 1 ? <em key={i}>{part}</em> : <Fragment key={i}>{part}</Fragment>
  );
};

export function ExpertTeam({
  eyebrow = 'VOTRE ÉQUIPE',
  title = 'Les compétences mobilisées',
  highlightedTitle = '*pour livrer votre application*',
  description = 'Un interlocuteur unique et les écrans de l’application conçue pour vos équipes.',
  appImage,
  appAlt = 'Capture d’écran de l’application',
  tilt = 'left',
  id,
}: ExpertTeamProps) {
  useAOS();

  const tiltClass = tilt === 'left' ? styles.tiltLeft : styles.tiltRight;

  return (
    <section id={id} className={`${styles.root} ${tiltClass}`} aria-label={title}>
      {appImage && (
        <div className={styles.bgImageWrap} aria-hidden="true">
          <Image
            src={appImage}
            alt={appAlt}
            fill
            priority={false}
            sizes="100vw"
            className={styles.bgImage}
          />
          <div className={styles.bgOverlay} />
        </div>
      )}
      <div className={styles.bgFallback} aria-hidden="true" />

      <div className={styles.inner}>
        <div className={styles.header} data-aos="fade-up" data-aos-duration="700">
          {eyebrow && <p className={styles.eyebrow}>{eyebrow}</p>}
          <h2 className={styles.title}>
            {renderTitle(title)}
            {highlightedTitle && (
              <span className={styles.highlight}> {renderTitle(highlightedTitle)}</span>
            )}
          </h2>
          {description && <p className={styles.description}>{description}</p>}
        </div>
      </div>
    </section>
  );
}
